const ARROW_RIGHT = 'ArrowRight';
const ARROW_LEFT = 'ArrowLeft';
const ARROW_UP = 'ArrowUp';
const ARROW_DOWN = 'ArrowDown';
const TAB = 'Tab';
const keyCodes = [ARROW_RIGHT, ARROW_LEFT, ARROW_UP, ARROW_DOWN, TAB];

/**
 *
 * @param {carousel} instance of Siema carousel
 * @param {slideSelector} selector of the carousel slide
 * @param {direction} direction of the carousel: "horizontal" or "vertical"
 * @param {parent} parent element of the slides in case of not Siema carousel
 * @returns {function} unbindKeyboardNavigation function to remove event listener
 */

export const handleCarouselKeyboardNavigation = ({ carousel, slideSelector, direction = 'horizontal', parent }) => {
  const keyboardHandler = (event) => {
    const carouselElement =
      typeof carousel?.config?.selector === 'string'
        ? document.querySelector(carousel.config.selector)
        : carousel?.config?.selector;
    const parentElement = carouselElement || parent;
    if (
      !document.activeElement ||
      !parentElement?.contains(document.activeElement) ||
      !document.activeElement?.classList.contains(slideSelector) ||
      !keyCodes.includes(event.key)
    ) {
      return;
    }

    const { isPrev, isNext } = checkDirection(direction, event);
    const { prevElement, nextElement } = getSiblings();

    if (isPrev() && prevElement) {
      event.preventDefault();
      carousel?.prev();
      prevElement?.focus();
    } else if (isNext() && nextElement) {
      event.preventDefault();
      carousel?.next();
      nextElement?.focus();
    }
  };
  document.addEventListener('keydown', keyboardHandler);

  return () => {
    document.removeEventListener('keydown', keyboardHandler);
  };
};

function checkDirection(direction, event) {
  if (direction === 'horizontal') {
    return {
      isPrev: () => event.key === ARROW_LEFT || (event.shiftKey && event.key === TAB),
      isNext: () => event.key === ARROW_RIGHT || (!event.shiftKey && event.key === TAB),
    };
  }
  return {
    isPrev: () => event.key === ARROW_UP || (event.shiftKey && event.key === TAB),
    isNext: () => event.key === ARROW_DOWN || (!event.shiftKey && event.key === TAB),
  };
}

function getSiblings() {
  return {
    prevElement: document.activeElement?.parentElement?.previousElementSibling?.firstElementChild,
    nextElement: document.activeElement?.parentElement?.nextElementSibling?.firstElementChild,
  };
}
